import axios from 'axios';
import store from '@/store/enterprise/index.js';
import { smallNotification } from '@/shared-modules/services/gf.notification.service';
import qs from 'qs';

export default {
  getInstanceCategories(params) {
    return axios
      .get(`/api/registry/package/categories`, { params })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  getProjectCategories(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/package/categories`, { params })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  getCompanyCategories(alias, params) {
    return axios
      .get(`/api/company/${alias}/package/categories`, { params })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  postProjectGroups(userAlias, projectAlias, data) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/package/pypi/create`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        data.getAll('files').forEach((file) => {
          store.dispatch('sendGroups', file?.name);
        });
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  postCompanyGroups(alias, data) {
    return axios
      .post(`/api/company/${alias}/package/pypi/create`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        data.getAll('files').forEach((file) => {
          store.dispatch('sendGroups', file?.name);
        });
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  postInstanceGroups(data) {
    return axios
      .post(`/api/registry/package/pypi/create`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        data.getAll('files').forEach((file) => {
          store.dispatch('sendGroups', file?.name);
        });
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  getUserGpgKeys() {
    return axios
      .get(`/api/settings/profile/list-gpg-keys`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' });
        throw err;
      });
  },
  getSelectedProjectGpgKey(userAlias, projectAlias, packageType) {
    // api/project/{userAlias}/{projectAlias}/setting/registy/key
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/setting/registry/key`, {
        params: { registryType: packageType }
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getSelectedCompanyGpgKey(companyAlias, packageType) {
    return axios
      .get(`/api/company/${companyAlias}/key`, {
        params: { packageType: packageType }
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getSelectedInstanceGpgKey(packageType) {
    return axios.get(`/api/admin/setting/registry/key`, {
      params: { packageType: packageType }
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    })
  }
};
